// @ts-ignore
import {HttpClient} from '@angular/common/http';
// @ts-ignore
import {Injectable} from '@angular/core';
// @ts-ignore
import {Observable, shareReplay} from 'rxjs';
import {AuthService} from './auth.service';

export interface UsuarioLogadoDadosResponse {
    sucesso: boolean;
    codusu: number;
    nomeUsuario: string;
    nomeCompleto: string;
    email: string;
    dados: Record<string, unknown>;
    erro?: string;
}

// @ts-ignore
@Injectable({providedIn: 'root'})
export class UsuarioLogadoService {
    private readonly apiUrl = '/api/sankhya/usuario-logado';
    private dadosCache$?: Observable<UsuarioLogadoDadosResponse>;
    private usuarioCache = '';

    constructor(
        private readonly http: HttpClient,
        private readonly authService: AuthService
    ) {
    }

    buscarDados(): Observable<UsuarioLogadoDadosResponse> {
        const usuarioAtual = this.authService.getUserId();
        if (this.usuarioCache !== usuarioAtual) {
            this.dadosCache$ = undefined;
            this.usuarioCache = usuarioAtual;
        }

        if (!this.dadosCache$) {
            this.dadosCache$ = this.http
                .get<UsuarioLogadoDadosResponse>(`${this.apiUrl}/dados`)
                .pipe(shareReplay(1));
        }

        return this.dadosCache$;
    }

    limparCache(): void {
        this.dadosCache$ = undefined;
        this.usuarioCache = '';
    }
}
